<template>
    <div class="page-card">
        <el-dialog
                title="Добавить автомобиль"
                :visible.sync="addVisible"
                width="435px"
        >
            <div>
                <el-form class="m-t-10" ref="validationForm" :model="model" v-loading="loading">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Марка автомобиля" prop="Model" :rules="[{ required: true, message: 'Марка автомобиля не заполнена' }]">
                                <el-input v-model="model.Model" placeholder="Марка автомобиля"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Гос. номер" prop="Plate" :rules="[{ required: true, message: 'Гос. номер не заполнен' }]">
                                <el-input v-model="model.Plate" placeholder="Гос. номер"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Цвет" prop="Color" :rules="[{ required: true, message: 'Цвет не указан' }]">
                                <el-color-picker v-model="model.Color"></el-color-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12" align="left" class="d-flex align-items-left">
                            <el-form-item label="" prop="AllowPassageByPlate" class="m-b-0">
                                <el-checkbox class="m-l-0" v-model="model.AllowPassageByPlate">Разрешить въезд</el-checkbox>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" align="right" class="d-flex align-items-right">
                            <el-button type="primary" class="w-100" icon="el-icon-plus" @click="add" :loading="loading">Добавить</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </el-dialog>

        <el-card shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :span="18">
                    <h2 class="m-b-0">Карта №{{ getCardName() }}</h2>
                </el-col>
                <el-col :span="6" align="right" v-if="$loginType() === 1 && dataTableCustomer && dataTableCustomer.find(x => x.View.Name === 'Customer') && dataTableCustomer.find(x => x.View.Name === 'Customer').Value">
                    <el-button
                            class="font-weight-bold"
                            @click="$router.push({ name: 'customerDetails', params: { id: dataTableCustomer.find(x => x.View.Name === 'Customer').ObjectId } })"
                            icon="icon-rotate-ccw"
                    >
                        {{dataTableCustomer.find(x => x.View.Name === 'Customer').Value}}
                    </el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :sm="24" :md="24" :lg="12" :xl="12" class="m-b-10 m-b-lg-0">
                <el-card shadow="never" class="m-b-20">
                    <el-tabs v-model="activeTab">
                        <el-tab-pane label="Информация" name="info">
                            <el-row :gutter="60">
                                <el-col :sm="24" :md="12" :lg="12" :xl="12">
                                    <div>
                                        <el-checkbox v-model="showCardData" class="float-right">Доп. информация</el-checkbox>
                                        <h2 >Карта №{{ getCardName() }}</h2>
                                        <el-table v-loading="loading" :data="dataTableCustomerFiltered">
                                            <el-table-column prop="name" label="">
                                                <template slot-scope="scope">
                                                    <div class="font-weight-bold">
                                                        {{ scope.row.View.DisplayName || scope.row.View.Name }}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="value" label="">
                                                <template slot-scope="scope">
                                                    <Input2 :itemType="itemType" :value="scope.row.Value" :view="scope.row.View" :key="render(scope.$index)" />
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                    <div class="m-t-40">
                                        <h2>Время въезда/выезда</h2>
                                        <el-table v-loading="loading" :data="dataTableOnline">
                                            <el-table-column prop="name" label="">
                                                <template slot-scope="scope">
                                                    <div class="font-weight-bold">
                                                        {{ scope.row.View.DisplayName || scope.row.View.Name }}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="value" label="">
                                                <template slot-scope="scope">
                                                    <Input2 :itemType="itemType" :value="scope.row.Value" :view="scope.row.View" />
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-col>
                                <el-col :sm="24" :md="12" :lg="12" :xl="12" class="m-t-40 m-t-md-0">
                                    <div>
                                        <h2>Тариф</h2>
                                        <el-table v-loading="loading" :data="dataTablePayment">
                                            <el-table-column prop="name" label="">
                                                <template slot-scope="scope">
                                                    <div class="font-weight-bold">
                                                        {{ scope.row.View.DisplayName || scope.row.View.Name }}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="value" label="">
                                                <template slot-scope="scope">
                                                    <Input2 :itemType="itemType" :value="scope.row.Value" :view="scope.row.View" />
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="Транзакции" name="logs">
                            <el-table v-loading="loading" :data="transTable">
                                <el-table-column prop="ID" label="ID" v-if="$mobile()"></el-table-column>
                                <el-table-column prop="tType" label="Тип">
                                    <template slot-scope="scope">
                                        <div class="font-weight-bold">
                                            {{scope.row.tType}}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="TimeEntry" label="Въезд">
                                    <template slot-scope="scope">
                                        <table-date :date="scope.row.TimeEntry"/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="TimeExit" label="Выезд">
                                    <template slot-scope="scope">
                                        <table-date :date="scope.row.TimeExit"/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="TimeParking" label="На парковке" v-if="$mobile()">
                                    <template slot-scope="scope">
                                        {{scope.row.TimeParking}}
                                    </template>
                                </el-table-column>
                            </el-table>

                            <el-row :gutter="20" class="m-t-30">
                                <el-col :sm="24" :md="24" :lg="12" :xl="12">
                                    <h3>Время въезда</h3>
                                    <img class="w-100" src="~assets/img/nophoto.png">
                                </el-col>
                                <el-col :sm="24" :md="24" :lg="12" :xl="12">
                                    <h3>Время выезда</h3>
                                    <img class="w-100" src="~assets/img/nophoto.png">
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                    </el-tabs>
                </el-card>
            </el-col>
            <el-col :sm="24" :md="24" :lg="12" :xl="12">
                <el-table v-loading="loadingCars" :data="carsTable">
                    <el-table-column prop="Model" label="Модель">
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                <a href="#" @click.prevent="showDetails(scope.row.ID)" class="color-black">
                                    {{ scope.row.Model }}
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Plate" label="Гос. Номер" />
                    <el-table-column prop="Color" label="Цвет" v-if="$mobile()">
                        <template slot-scope="scope">
                            <div class="car-color" :style="{ backgroundColor: $getColor(scope.row.Color) }">
                                &nbsp;
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="AllowPassageByPlate" label="Проезд по гос. номеру" v-if="$mobile()">
                        <template slot-scope="scope">
                            <div v-if="scope.row.AllowPassageByPlate" class="font-weight-bold color-success">
                                Да
                            </div>
                            <div v-else class="font-weight-bold color-danger">
                                Нет
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="!customerTypeSingle && $loginType() === 1" align="right" class="m-t-20">
                    <el-button @click="addForm" icon="icon-plus">Добавить авто</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Input2 from '@/components/Input2'

    export default {
        components: { Input2 },
        data () {
            return {
                activeTab: 'info',
                itemType: 'Card',
                loading: false,
                loadingCars: false,
                total: 0,
                dataTableCustomer: [],
                dataTableOnline: [],
                dataTablePayment: [],
                carsTable: [],
                transTable: [
                    {
                        ID: 10012,
                        tType: 'Въезд',
                        TimeEntry: '2020-03-25 00:00:00',
                        TimeExit: '2020-03-25 19:24:00',
                        TimeParking: '00:38:10'
                    },
                    {
                        ID: 10013,
                        tType: 'Выезд',
                        TimeEntry: '2020-03-24 09:00:04',
                        TimeExit: '2020-03-25 12:14:30',
                        TimeParking: '11:50:19'
                    }
                ],
                cardId: this.$route.params.id,
                addVisible: false,
                model: {
                    CardID: this.$route.params.id,
                    Color: '#409EFF'
                },
                showCardData: false,
                customerTypeSingle: false
            }
        },
        created () {
            this.getCars()
            this.getData()
        },
        computed: {
            dataTableCustomerFiltered () {
                if (this.showCardData) {
                    return this.dataTableCustomer.filter(x => x.View.Name !== 'Name')
                }
                else {
                    return this.dataTableCustomer.filter(x => x.View.Name !== 'Name' && x.View.Name !== 'DbName' && x.View.Name !== 'CardType' && x.View.Name !== 'LifetimeBegin' && x.View.Name !== 'ErrorsCount' && x.View.Name !== 'TimeExpiration')
                }
            }
        },
        methods: {
            getData () {
                this.loading = true

                let request = {
                    Name: "GetItemView",
                    ItemType: "Card",
                    OperatorName: "Admin",
                    ItemId: this.cardId
                }

                this.$api.Main.getCards(request).then(response => {
                    this.loading = false
                    this.dataTableCustomer = response.Parameters.filter(x => x.View.Category === 'Customer')
                    this.dataTableOnline = response.Parameters.filter(x => x.View.Category === 'Online')
                    this.dataTablePayment = response.Parameters.filter(x => x.View.Category === 'Payment')

                    response.Parameters.map(row => {
                        if (row.View.Name === 'CustomerType' && row.Value === 'Разовый') this.customerTypeSingle = true
                    })
                }).catch (() => {
                    this.loading = false
                })
            },
            //-- cars block
            getCars () {
                this.loadingCars = true

                let request = {
                    Name: "GetItemsList",
                    ItemType: "Car"
                }
                request.Filter = {
                    Type: "Simple",
                    Field: "CardID",
                    Operation: "Equal",
                    Value: this.cardId
                }

                this.$api.Main.getCars(request).then(response => {
                    console.log(response)
                    this.loadingCars = false
                    this.carsTable = response.Items
                    this.total = response.Total
                }).catch (() => {
                    this.loadingCars = false
                })
            },
            showDetails (id) {
                this.$router.push({ name: 'carDetails', params: { id: id } })
            },
            add () {
                this.$refs['validationForm'].validate((valid) => {
                    if (valid) {
                        this.clearFormErrors('validationForm')
                        this.loading = true

                        let request = Vue.$props('AddItem', 'Car', this.model)

                        this.$api.Main.addCard(request).then(response => {
                            this.loading = false

                            if (response.Result === "Success") {
                                this.resetForm()
                                this.$message({
                                    message: 'Автомобиль добавлен',
                                    type: 'success',
                                    res: response
                                })

                                this.addVisible = false
                                this.getCars()

                                setTimeout(() => this.clearFormErrors('validationForm'), 500)
                            }
                            else {
                                this.$message({
                                    message: response.ErrorString,
                                    type: 'error',
                                    res: response
                                })
                            }
                        }).catch((error) => {
                            this.loading = false
                            this.showFormErrors(error, 'validationForm')
                        })
                    }
                })
            },
            addForm () {
                this.resetForm()
                setTimeout(() => this.clearFormErrors('validationForm'), 1)
                this.addVisible = true
            },
            resetForm () {
                this.model = {
                    CardID: this.$route.params.id,
                    Model: '',
                    Color: '',
                    Plate: '',
                    AllowPassageByPlate: false
                }
            },
            close () {
                this.addVisible = false
                this.resetForm()
                setTimeout(() => this.clearFormErrors('validationForm'), 500)
            },
            render (index) {
                return Math.round(index + (10 + Math.random() * (9999999 - 10 + 1)))
            },
            getCardName () {
                let card = this.dataTableCustomer.find(x => x.View.Name === 'Name')
                if (card && card.Value) return card.Value
                else return card
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
